import '../../App.less';
import {Spin,Badge, Layout,Tabs, Select,Comment,Avatar, Row, Col,ConfigProvider,Table,Modal,Menu,Input, Space,notification,AutoComplete, Card, Checkbox } from 'antd';
import React, { Component } from "react";
import 'react-phone-input-2/lib/style.css'
import es_ES from 'antd/lib/locale/es_ES';
import { Button } from 'antd';
import Highlighter from 'react-highlight-words';
import {MinusOutlined,CheckOutlined,StarOutlined,MailOutlined, PhoneOutlined, GlobalOutlined, EnvironmentOutlined, IdcardOutlined, LikeOutlined,DislikeOutlined, SearchOutlined,CalendarOutlined,EditOutlined, UserOutlined,TagsOutlined,FileTextOutlined,FilePdfOutlined, AuditOutlined,QrcodeOutlined,BarChartOutlined } from '@ant-design/icons';
import moment from 'moment'
import axios from "axios";
import generatePDFConc from './services/reportGenerator' 
import generatePDFPlay from './services/reportGeneratorPlays' 
import {getAuthors,getAuthorsStr, getCountryName,IP,getCountryCode, countDownNotification} from '../components/utils';
import Foot from "../components/Footer"
import AdminMenu from "../components/AdminMenu"

class Playslist extends Component {
  constructor(props){
    super(props)
    this.state={
      plays:[],
      showArticle:false,
      record:null,
      recordAuthor:null,
      edit:false,
      categoryChanged:"",
      conc:[],
      filteredInfo:[],
      makeGenreReport:false,
      reportGenre:'Novela',
      reportCountry:null,
      makeCountryReport:false,
      selectedRows:[],
      qualifiedChanged:false,
      qualifiedChangedValue:undefined,
      preselectedChanged:false,
      preselectedChangedValue:undefined,
      showCommentSection:false,
      comment:{},
      edit_comment:undefined,
      selected_comment:undefined,
      comment_new_text:undefined,
      comment_answer_text:undefined,
      jurys_dict:{},
      juryId:undefined,
      logued:false,
      reportByAuthor:true,
      isBusy:false,
      showAuthor:false
    }
  }
  async componentDidMount() {
    //Plays
    const response_plays = await fetch(IP + 'api/casa/obra/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    const json_plays = await response_plays.json();
    if(json_plays['detail']){
      localStorage.clear()
      window.location.reload(); 
    }
    
    //Jury
    const response_jury= await fetch(IP + 'api/casa/jurado/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    const json_jury = await response_jury.json();
   
    const jury_user = localStorage.getItem("User")
    var current_jury = json_jury.filter(j=>j.usuario.toLowerCase() ==jury_user.toLowerCase())[0]
    const jurys_dict={}
    Object.entries(json_jury).forEach(element => {
      jurys_dict[element[1].id]=element[1]
    });

    //Genre
    const genr = await fetch(IP + 'api/casa/genero/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    this.json_g = await genr.json();
    this.genres_dict = {};
    this.json_g.forEach(element => {
      this.genres_dict[element.id] = element.nombre
    });

    
    var data = []
    this.authorsStr = new Set();
    this.auths = new Set();
    this.categories = new Set();
    this.codes = new Set();
    this.titles = new Set();
    this.dates = new Set();
    this.pseudos = new Set();
    this.edits = [];
    this.countries = new Set();
    
    var poesia = []
    var ensayo = []
    var novela = []
    const Moment = require('moment');
   
    const json_conc = [].concat.apply([],json_plays.map(play=> {return play.conc})) 
    for(var i in json_plays){
      var item = json_plays[i];
      var date= new Moment(item.fecha_registro).format('DD-MM-YYYY')
      var author= getAuthors(item.conc)
      var a= getAuthorsStr(item.conc)
      for(var j in a ){
        this.authorsStr.add(a[j])
      }
      const year = date.split('-')[2]
      
      var authorStr = getAuthorsStr(item.conc).join(", ")
      this.auths.add(author)
      this.categories.add(this.genres_dict[item.genero])
      this.codes.add(year+'_'+item.genero+'_'+item.id);
      this.titles.add(item.titulo);
      this.dates.add(date);
      this.edits.push("")
      this.pseudos.add(item.pseudonimo)
      this.countries.add(getCountryName(item.conc[0].pais))
      data.push(
          { 
              key : item.id,
              id : item.id,
              title : item.titulo,
              author: author ,
              conc:item.conc,
              authorStr:authorStr,
              date:date,
              unixDate: new Moment(item.fecha_registro).unix(),
              pseudo: item.pseudonimo,
              code:year+'_'+item.genero+'_'+item.id,
              conc:item.conc,
              category:this.genres_dict[item.genero],
              categoryObj:{id:item.genero, nombre:this.genres_dict[item.genero] },
              pdf:item.pdf,
              edit:'',
              qualified:item.califica,
              preselected:item.preseleccionada
          });
        var  pdf = item.pdf.split('/')
      if (item.genero == 1)
        poesia.push(pdf[pdf.length-1])
      if (item.genero == 3)
        ensayo.push(pdf[pdf.length-1])
      if (item.genero == 2)
        novela.push(pdf[pdf.length-1])
    
    };
    var data_conc = []

    this.names = new Set();
    this.emails = new Set();
    
    for(var i in json_conc){
      var item = json_conc[i];
      
      this.names.add(item.nombre_completo)
      this.emails.add(item.email)
      data_conc.push(
          { 
              id : item.id,
              name : item.nombre_completo,
              country: item.pais,
              countryName: getCountryName(item.pais),
              ficha: item.ficha,
              phone: item.telefono,
              address: item.direcc_personal,
              email: item.email,
          });
    };
    this.auths = [...this.auths].map((v)=>{
      return {value:v}
    })
    this.categories =[...this.categories].map((v)=>{
      return {value:v}
    })
    this.codes = [...this.codes].map((v)=>{
      return {value:v}
    })
    this.titles = [...this.titles].map((v)=>{
      return {value:v}
    })
    this.dates = [...this.dates].map((v)=>{
      return {value:v}
    })

    this.pseudos = [...this.pseudos].map((v)=>{
      return {value:v}
    })
    
    this.authorsStr = [...this.authorsStr].map((v)=>{
      return {value:v}
    })
    this.setState({ plays: data , conc:data_conc, filteredInfo:data, jurys_dict:jurys_dict,juryId:current_jury.id,logued:true, name:current_jury.nombre_completo});
   
  }
  
  async getPlays(){//loads all plays and its details
    const Moment = require('moment');
    var data = []
    this.setState({isBusy:true})
    const response = await fetch(IP + 'api/casa/obra/',{
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    });
    const json = await response.json();
    if(json['detail']){
      localStorage.clear()
      window.location.reload(); 
    }
    for(var i in json){
      var item = json[i];
      var date= new Moment(item.fecha_registro).format('DD-MM-YYYY')
      var author= getAuthors(item.conc)
      const year = date.split('-')[2]
      var authorStr = getAuthorsStr(item.conc).join(", ")
      data.push(
          { 
            key : item.id,
            id : item.id,
            title : item.titulo,
            author: author ,
            conc:item.conc,
            authorStr:authorStr,
            date:date,
            pseudo: item.pseudonimo,
            code:year+'_'+item.genero+'_'+item.id,
            category:this.genres_dict[item.genero],
            categoryObj:{id:item.genero, nombre:this.genres_dict[item.genero] },
            pdf:item.pdf,
            edit:'',
            qualified:item.califica,
            preselected:item.preseleccionada
          });
    };
    this.setState({ plays: data,isBusy:false})
  }

  async changeQualification(id,value,preselectedValue){
    var options = {
      method: "patch",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
      proxy: {
        host: 'localhost:8000',
        port: 8000
      }
    }
    
    var playChanged={
      "califica":value,
      "preseleccionada": value == null || value == true ? null: false
  }
    await axios.patch(IP + `api/casa/obra/${id}/`, playChanged, options)
    .then(
      (response) => {
        if(response.status === 200){
         var userId = localStorage.getItem("UserId")
          
           const data_log= new FormData()
           data_log.append('usuario',userId)
           data_log.append('accion',value ==null ?"Estado de obra cambiado a sin determinar calificación" : value ?"Estado de obra cambiado a calificada":"Estado de obra cambiado a descalificada")
           data_log.append('obra',id)
           axios.post(IP + 'api/casa/logs/', data_log).then((val)=>this.getPlays())
        }
         
         else{
           notification.error({
           message:'Error',
           description:'Hubo un error, por favor revise los datos',
         });
         }
      },
      (error) => {
       notification.error({
         message:'Error',
         description:'Hubo un error, por favor revise los datos',
       });
      }
    ).catch((err) => notification.error({
     message:'Error',
     description:'Hubo un error, por favor revise los datos',
   }))
  }
  async changePreselection(id,value){
    var options = {
      method: "patch",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
      proxy: {
        host: '200.55.135.1',
        port: 8000
      }
    }
   
    var playChanged= value == true ? {"preseleccionada":value,"califica":true}:{"preseleccionada":value}
    await axios.patch(IP + `api/casa/obra/${id}/`, playChanged, options)
    .then(
      (response) => {
        if(response.status === 200){
         var userId = localStorage.getItem("UserId")
          
           const data_log= new FormData()
           data_log.append('usuario',userId)
           data_log.append('accion',value ==null ?"Estado de obra cambiado a sin determinar preselección" : value ?"Estado de obra cambiado a preseleccionada":"Estado de obra cambiado a no preseleccionada")
           data_log.append('obra',id)
           axios.post(IP + 'api/casa/logs/', data_log).then((val)=>this.getPlays())
        }
         
         else{
           notification.error({
           message:'Error',
           description:'Hubo un error, por favor revise los datos',
         });
         }
      },
      (error) => {
       notification.error({
         message:'Error',
         description:'Hubo un error, por favor revise los datos',
       });
      }
    ).catch((err) => notification.error({
     message:'Error',
     description:'Hubo un error, por favor revise los datos',
   }))
  }

  async qualifyAll(){
    this.setState({isBusy:true})
    var data={}
    data['ids'] =  this.state.selectedRows
    data['califica'] = true
    
   var options = {
      method: "put",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
      body:JSON.stringify(data)
     
    }
    await fetch(IP + `api/casa/obra/`, options)
    .then(
      async(response) => {
        if(response.status === 200 || response.status === 201){
          var data={}
          data['ids'] =  this.state.selectedRows
          var userId = localStorage.getItem("UserId")

          data['usuario'] = userId
          data['accion'] = "Estado de obra cambiado a calificada"
          
          var options = {
              method: "post",
              credentials: "same-origin",
              headers: {
                "Authorization": localStorage.getItem("Authorization") ,
                "Accept": "application/json",
                "Content-Type": "application/json"},
              body:JSON.stringify(data)
            }
          fetch(IP + `api/casa/logs/`, options).then(response=> this.getPlays())
        }
      },
      (error) => {
        this.setState({isBusy:false})
        countDownNotification(notification.error,'Error','Por favor intente más tarde','error');
      }
    ).catch((err) => countDownNotification(notification.error,'Error','Por favor intente más tarde','error'))
  }
  async undefinedQualifyAll(){
    this.setState({isBusy:true})
    var data={}
    data['ids'] =  this.state.selectedRows
    data['califica'] = "undefined"
    data['preseleccionada'] = "undefined"
    
   var options = {
      method: "put",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
      body:JSON.stringify(data)
     
    }
    await fetch(IP + `api/casa/obra/`, options)
    .then(
      async(response) => {
       if(response.status === 200 || response.status === 201){
        var data={}
        data['ids'] =  this.state.selectedRows
        var userId = localStorage.getItem("UserId")

        data['usuario'] = userId
        data['accion'] = "Estado de obra cambiado a descalificada"
        
        var options = {
            method: "post",
            credentials: "same-origin",
            headers: {
              "Authorization": localStorage.getItem("Authorization") ,
              "Accept": "application/json",
              "Content-Type": "application/json"},
            body:JSON.stringify(data)
          
          }
        fetch(IP + `api/casa/logs/`, options).then((response)=>this.getPlays())
       }
       
      },
      (error) => {
        console.log(error);
      }
    ).catch((err) => console.log(err))
  }
  async unqualifyAll(){
    this.setState({isBusy:true})
    var data={}
    data['ids'] =  this.state.selectedRows
    data['califica'] = false
    data['preseleccionada'] = false
    
   var options = {
      method: "put",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
      body:JSON.stringify(data)
     
    }
    await fetch(IP + `api/casa/obra/`, options)
    .then(
      async(response) => {
       if(response.status === 200 || response.status === 201){
        var data={}
        data['ids'] =  this.state.selectedRows
        var userId = localStorage.getItem("UserId")

        data['usuario'] = userId
        data['accion'] = "Estado de obra cambiado a descalificada"
        
        var options = {
            method: "post",
            credentials: "same-origin",
            headers: {
              "Authorization": localStorage.getItem("Authorization") ,
              "Accept": "application/json",
              "Content-Type": "application/json"},
            body:JSON.stringify(data)
          }
        fetch(IP + `api/casa/logs/`, options).then((response)=>this.getPlays())
      }
      },
      (error) => {
        console.log(error);
      }
    ).catch((err) => console.log(err))
  }
  async undefinedPreselectAll(){
    this.setState({isBusy:true})
    var data={}
    data['ids'] =  this.state.selectedRows
    data['califica'] = false
    data['preseleccionada'] = undefined
    
   var options = {
      method: "put",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
      body:JSON.stringify(data)
     
    }
    await fetch(IP + `api/casa/obra/`, options)
    .then(
      async(response) => {
       if(response.status === 200 || response.status === 201){
        var data={}
        data['ids'] =  this.state.selectedRows
        var userId = localStorage.getItem("UserId")

        data['usuario'] = userId
        data['accion'] = "Estado de obra cambiado a descalificada"
        
        var options = {
            method: "post",
            credentials: "same-origin",
            headers: {
              "Authorization": localStorage.getItem("Authorization") ,
              "Accept": "application/json",
              "Content-Type": "application/json"},
            body:JSON.stringify(data)
          
          }
        fetch(IP + `api/casa/logs/`, options).then((response)=>this.getPlays())
       }
       
      },
      (error) => {
        console.log(error);
      }
    ).catch((err) => console.log(err))
  }
  async preselectAll(){
    this.setState({isBusy:true})
    var data={}
    data['ids'] =  this.state.selectedRows
    data['preseleccionada'] = true
    data['califica'] = true
    
   var options = {
      method: "put",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
      body:JSON.stringify(data)
     
    }
    await fetch(IP + `api/casa/obra/`, options)
    .then(
      async(response) => {
       if(response.status === 200 || response.status === 201){
        var data={}
        data['ids'] =  this.state.selectedRows
        var userId = localStorage.getItem("UserId")

        data['usuario'] = userId
        data['accion'] = "Estado de obra cambiado a preseleccionada"
        
        var options = {
            method: "post",
            credentials: "same-origin",
            headers: {
              "Authorization": localStorage.getItem("Authorization") ,
              "Accept": "application/json",
              "Content-Type": "application/json"},
            body:JSON.stringify(data)
          
          }
        fetch(IP + `api/casa/logs/`, options).then((response)=>this.getPlays())
       }
      },
      (error) => {
        console.log(error);
      }
    ).catch((err) => console.log(err))
  }
  async depreselectAll(){
    this.setState({isBusy:true})
    var data={}
    data['ids'] =  this.state.selectedRows
    data['preseleccionada'] = false
    
   var options = {
      method: "put",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
      body:JSON.stringify(data)
     
    }
    await fetch(IP + `api/casa/obra/`, options)
    .then(
      async(response) => {
       if(response.status === 200 || response.status === 201){
        var data={}
        data['ids'] =  this.state.selectedRows
        var userId = localStorage.getItem("UserId")

        data['usuario'] = userId
        data['accion'] = "Estado de obra cambiado a no preseleccionada"
        
        var options = {
            method: "post",
            credentials: "same-origin",
            headers: {
              "Authorization": localStorage.getItem("Authorization") ,
              "Accept": "application/json",
              "Content-Type": "application/json"},
            body:JSON.stringify(data)
          
          }
        fetch(IP + `api/casa/logs/`, options).then((response)=>this.getPlays())
       }
       
      },
      (error) => {
        console.log(error);
      }
    ).catch((err) => console.log(err))
  }

  onClickArticle = record  => {
        this.setState({showArticle:true,record:record});
  };
  onchangeTab(tab){
    var plays = []
    if(tab=="1"){//all plays
      plays = this.state.plays
    }
    if(tab=="2"){//qualified
      plays = this.state.plays.filter(p=>p.qualified)
    }
    if(tab=="3"){//not qualified
      plays = this.state.plays.filter(p=>p.qualified==undefined ? false:!p.qualified)
    }
    if(tab=="4"){//not analyzed to be qualified
      plays = this.state.plays.filter(p=>p.qualified==undefined)
    }
    if(tab=="5"){//preselected
      plays = this.state.plays.filter(p=>p.preselected)
    }
    if(tab=="6"){//not preselected
      plays = this.state.plays.filter(p=>p.preselected==undefined ? false:!p.preselected)
    }
    if(tab=="7"){//not analyzed to be preselected
      plays = this.state.plays.filter(p=>p.preselected==undefined)
    }
   
    this.authorsStr = new Set();
    this.auths = new Set();
    this.categories = new Set();
    this.codes = new Set();
    this.titles = new Set();
    this.dates = new Set();
    this.pseudos = new Set();
    this.countries = new Set();
    plays.forEach(play =>{
      var a= getAuthorsStr(play.conc)
      for(var j in a ){
        this.authorsStr.add(a[j])
      }
      this.auths.add(play.author)
      this.categories.add(play.category)
      this.codes.add(play.code)
      this.titles.add(play.title)
      this.dates.add(play.date)
      this.pseudos.add(play.pseudo)
      this.countries.add(getCountryName(play.conc[0].pais))
    })
    this.auths = [...this.auths].map((v)=>{
      return {value:v}
    })
    this.categories =[...this.categories].map((v)=>{
      return {value:v}
    })
    this.codes = [...this.codes].map((v)=>{
      return {value:v}
    })
    this.titles = [...this.titles].map((v)=>{
      return {value:v}
    })
    this.dates = [...this.dates].map((v)=>{
      return {value:v}
    })

    this.pseudos = [...this.pseudos].map((v)=>{
      return {value:v}
    })
    
    this.authorsStr = [...this.authorsStr].map((v)=>{
      return {value:v}
    })
    this.setState({selectedRows:[]})
  }

 
  hideModal = () => {
        this.setState({
          showArticle: false,
          record: null,
        });
  };

  hideEdit = () => {
    this.setState({
      edit: false,
      record: null,
    });
};

  onClickEditPlay(record){
        this.setState({edit:true,record:record});
  };
  onChangeSelect(value){
    this.setState({categoryChanged:value})
  }
  async getComments(playId){
    const comments = await fetch(IP + `api/casa/comentario/?obra=${playId.toString()}`,{ method: "get",
    credentials: "same-origin",
    headers: {
      "Authorization": localStorage.getItem("Authorization") ,
      "Accept": "application/json",
      "Content-Type": "application/json"}})
    const json_comments = await comments.json();
    const comments_dict = {}
   
  
    if(json_comments['detail']){
      notification.error({
        message:'Error',
        description:'Hubo un error cargando los comentarios, por favor intente más tarde',
      })
      return {}
    }
    else{
      json_comments.forEach(element => {
        comments_dict[element.id] = element
        });
      return comments_dict
    }
  
  }
  async openComments(record){
    var comments_dict = await this.getComments(record.id)
    this.setState({showCommentSection:true, currentRecordId:record.id, comment:comments_dict})
  }
  async postComment(play_id,parentComment,isAnswer=false){
    const data= new FormData()
    data.append('jurado',this.state.juryId)
    data.append('obra',play_id)
    data.append('texto',isAnswer ? this.state.comment_answer_text:this.state.comment_new_text)
    if(parentComment){
      data.append('comentario_padre',parentComment)
    }
    axios.post(IP + 'api/casa/comentario/', data).then(async (res) => {
      if (res.status == 200){
        const comments_dict = await this.getComments(play_id)
        this.setState({comment:comments_dict,selected_comment:undefined,answer_comment:false, comment_new_text:'', comment_answer_text:''})
      } 
      }).catch((err) => {
        notification.error({
          message:'Error',
          description:"Hubo un error. Intente mas tarde por favor",
        });
    })
  }

  async saveEditComment(play_id,commentId){
    var options = {
      method: "patch",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
     
    }
    var editedComment = {
      texto: this.state.comment_new_text
    }
    await axios.patch(IP + `api/casa/comentario/${commentId.toString()}/`, editedComment, options)
    .then(
      async(response) => {
       if(response.status === 200)
       var comments_dict = await this.getComments(play_id)
       this.setState({comment:comments_dict,edit_comment:false,selected_comment:undefined, comment_new_text:undefined},()=>countDownNotification(notification.success,'Completado','El mensaje se guardó de forma exitosa','success'))
      },
      (error) => {
        console.log(error);
      }
    ).catch((err) => console.log(err))
  }
  async deleteComment(play_id,commentId){
    fetch(IP + `api/casa/comentario/${commentId.toString()}/`,{
      method:'DELETE',
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"},
     
    }).then(async (res) => {
      if (res.status == 204){
        var comments_dict = await this.getComments(play_id)
        this.setState({comment:comments_dict},()=>countDownNotification(notification.success,'Completado','El mensaje se eliminó de forma exitosa','success'))
      } 
      }).catch((err) => {
        notification.error({
          message:'Error',
          description:"Hubo un error. Intente mas tarde por favor",
        });
    })
  }
  editComment(comment){
    this.setState({edit_comment:true,selected_comment:comment.id, comment_new_text:comment.texto})
  }
  cancelComment(){
    this.setState({edit_comment:false,selected_comment:undefined,answer_comment:false, comment_new_text:''})
  }
  answerComment(commentId){
    this.setState({selected_comment:commentId,answer_comment:true,edit_comment:false})
  }
  
  getChildComments(comment){
    const { TextArea } = Input;
    return (this.state.edit_comment && this.state.selected_comment == comment.id &&
      <Comment
      actions={[<span onClick={()=>this.saveEditComment(comment.obra,comment.id)} >Guardar</span>, <span onClick={()=>this.cancelComment()} >Cancelar</span>]}
          avatar={
            <Avatar
          src={`https://ui-avatars.com/api/name=${this.state.jurys_dict[comment.jurado].nombre_completo}&background=random`}
          alt={this.state.jurys_dict[comment.jurado].nombre_completo}
        />
          }
          content={
            <TextArea value={this.state.comment_new_text} onChange={(val)=>{this.setState({comment_new_text:val.target.value})}}/>
          }
        >
                {comment.respuestas.map(id => {
          return this.getChildComments(this.state.comment[id])
      })}
      </Comment>
          
      || (this.state.answer_comment && this.state.selected_comment == comment.id &&
        <Comment
      actions={comment.jurado==this.state.juryId ? [<span onClick={()=>this.editComment(comment)}>Editar</span>,<span onClick={()=>this.deleteComment(comment.obra, comment.id)} >Eliminar</span>,<span onClick={()=>this.answerComment(comment.id)} >Responder</span>]: [<span onClick={()=>this.answerComment(comment.id)}>Responder</span>]}
      author={<a>{this.state.jurys_dict[comment.jurado].nombre_completo}</a>}
      avatar={
        <Avatar
          src={`https://ui-avatars.com/api/name=${this.state.jurys_dict[comment.jurado].nombre_completo}&background=random`}
          alt={this.state.jurys_dict[comment.jurado].nombre_completo}
        />
      }
      content={
        <p>
          {comment.texto}
        </p>
      }
      datetime={
          <span>{moment(comment.fecha).format('YYYY-MM-DD HH:mm:ss')}</span>
      }
>       <Comment
        actions={[<Button type="primary" disabled={!this.state.comment_answer_text || this.state.comment_answer_text.replaceAll(/\s/g,'') === ""}onClick={()=>this.postComment(this.state.currentRecordId,comment.id,true)} >Comentar</Button>, <Button type="text" onClick={()=>this.cancelComment()} >Cancelar</Button>]}
            avatar={
              <Avatar
            src={`https://ui-avatars.com/api/name=${this.state.name}&background=random`}
            alt={this.state.name}
          />
            }
            content={
              <TextArea placeholder="Escriba " value={this.state.comment_answer_text} onChange={(val)=>this.setState({comment_answer_text:val.target.value})}/>
            }
          > 
        </Comment>
        {comment.respuestas.map(id => {
          return this.getChildComments(this.state.comment[id])
        })}
      </Comment>
      ) ||
      <Comment
      actions={comment.jurado==this.state.juryId ? [<span onClick={()=>this.editComment(comment)} key="comment-basic-edit-to">Editar</span>,<span  onClick={()=>this.deleteComment(comment.obra, comment.id)}  key="comment-basic-delete-to">Eliminar</span>,<span onClick={()=>this.answerComment(comment.id)}  key="comment-basic-reply-to">Responder</span>]: [<span onClick={()=>this.answerComment(comment.id)}  key="comment-basic-reply-to">Responder</span>]}
      author={<a>{this.state.jurys_dict[comment.jurado].nombre_completo}</a>}
      avatar={
        <Avatar
          src={`https://ui-avatars.com/api/name=${this.state.jurys_dict[comment.jurado].nombre_completo}&background=random`}
          alt={this.state.jurys_dict[comment.jurado].nombre_completo}
        />
      }
      content={
        <p>
          {comment.texto}
        </p>
      }
      datetime={
          <span>{moment(comment.fecha).format('YYYY-MM-DD HH:mm:ss')}</span>
      }
    >
      {comment.respuestas.map(id => {
          return this.getChildComments(this.state.comment[id])
      })}
      </Comment>
      )
    }

  handleTableChange = (pagination, filters, sorter, extra) => {
    this.setState({
      filteredInfo: extra['currentDataSource']
    });
  }
  onChangeSelectedRows(rows){
    this.setState({selectedRows:rows})
  }

  getAutocomplete = (dataIndex) =>{
    if(dataIndex == "code"){
      return this.codes
    }
    
      else if (dataIndex == "title" ) {
        return this.titles
    } 

    else if (dataIndex== "author"){
      return  this.authorsStr
    }

    else if (dataIndex== "category"){
      return this.categories
    }
    else if (dataIndex== "pseudo"){
      return this.pseudos
    }
    
    else{
      return this.dates
    }
  }
async onClickSave(){

  var options = {
     method: "patch",
     credentials: "same-origin",
     headers: {
       "Authorization": localStorage.getItem("Authorization") ,
       "Accept": "application/json",
       "Content-Type": "application/json"},
     proxy: {
       host: '200.55.135.1',
       port: 8000
     }
   }
   
   var playChanged={}
   var preselectedValue = this.state.preselectedChanged?this.state.preselectedChangedValue:this.state.record.preselected
   var qualifiedValue = this.state.qualifiedChanged?this.state.qualifiedChangedValue:this.state.record.qualified
     playChanged={
       titulo: document.getElementById("inputTitle").value,
       genero:this.state.categoryChanged? this.state.categoryChanged:this.state.record.categoryObj.id,
       pseudonimo: document.getElementById("inputPseudo").value,
       califica:preselectedValue ? true : qualifiedValue,
       preseleccionada : preselectedValue,
     }
   await axios.patch(IP + `api/casa/obra/${this.state.record.id}/`, playChanged, options)
   .then(
     (response) => {
       if(response.status === 200){
        var userId = localStorage.getItem("UserId")
        if(this.state.preselectedChanged){
          const data_log= new FormData()
          data_log.append('usuario',userId)
          data_log.append('accion',preselectedValue ? "Estado de obra cambiado a preseleccionada":"Estado de obra cambiado a no preseleccionada")
          data_log.append('obra',this.state.record.id)
          axios.post(IP + 'api/casa/logs/', data_log)
        }

        if(this.state.qualifiedChanged){
          const data_log= new FormData()
          data_log.append('usuario',userId)
          data_log.append('accion',qualifiedValue ? "Estado de obra cambiado a calificada":"Estado de obra cambiado a descalificada")
          data_log.append('obra',this.state.record.id)
          axios.post(IP + 'api/casa/logs/', data_log)
        }
         window.location.reload();
       }
        
        else{
          notification.error({
          message:'Error',
          description:'Hubo un error, por favor revise los datos',
        });
        }
     },
     (error) => {
      notification.error({
        message:'Error',
        description:'Hubo un error, por favor revise los datos',
      });
     }
   ).catch((err) => notification.error({
    message:'Error',
    description:'Hubo un error, por favor revise los datos',
  }))
   this.setState({qualifiedChanged:false,preselectedChanged:false,categoryChanged:""})
 }
  getColumnSearchProps = (dataIndex,nombre) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
            <AutoComplete 
            style={{ width: 188, marginBottom: 8, display: 'block' }}
            options={this.getAutocomplete(dataIndex)}
            filterOption={(inputValue,option)=>option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
            onChange={(value)=>{setSelectedKeys(value ? [value] : [])}}
            value={selectedKeys[0]}

            >
              <Input
                ref={node => {
                  this.searchInput = node;
                }}
                placeholder={`Buscar ${nombre}`}
                onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
              />
            </AutoComplete>
            <Space>
              <Button
                type="primary"
                onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
              >
                Buscar
              </Button>
              <Button onClick={() =>{setSelectedKeys([]); this.handleReset(clearFilters)}} size="small" style={{ width: 90 }}>
                Resetear
              </Button>
            </Space>

          </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
          dataIndex!="author"?
           (record[dataIndex]
            ? record[dataIndex].toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())
            : ''):
            (record[dataIndex]? record[dataIndex].some(auth=>auth['name'].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes(value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase())):'')
       ,
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => this.searchInput.select(), 100);
          }
        },
        render: (text,record,index) =>

           this.state.searchedColumn === dataIndex ? (
             dataIndex !="author"?
            (<div style={{fontSize:'large' }}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
            </div>):
            record[dataIndex].map(auth=>
            (<div style={{fontSize:'large' }}>
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={auth['name'] ? auth['name'] : ''}
            />
            </div>))
          ) : (
            <div style={{fontSize:'large' }}>
              {(dataIndex=='edit' && <a onClick={()=>{this.onClickEditPlay(record)}}> <EditOutlined /></a>)||(dataIndex=="author" && <ol>{record.author.map((a,idx)=>{return <li><a onClick = {()=>this.setState({showAuthor:true,record:record,recordAuthor:a.id})} >{a.name}</a> </li>})}</ol> )
              || (<a onClick = {()=>this.onClickArticle(record)} >  {text}</a> )  }
            </div>
          ),
      });
    
      handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
          searchText: selectedKeys[0],
          searchedColumn: dataIndex,
        });
      };
    
      handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });

      };
      
      getDataFromURL = (url) => new Promise((resolve, reject) => {
        setTimeout(() => {
            fetch(url)
                .then(response => response.text())
                .then(data => {
                    resolve(data)
                });
        });
    }, 2000);

  render() {
    /////Authors////
    const downloadPlayReport =()=> generatePDFPlay(this.state.plays,"save")
    const readPlayReport =()=> generatePDFPlay(this.state.plays,"read")

    const downloadPlayReportGenre =()=> generatePDFPlay(this.state.plays,"save",true)
    const readPlayReportGenre =()=> generatePDFPlay(this.state.plays,"read",true)

    const downloadCurrentReport =()=> generatePDFPlay(this.state.filteredInfo,"save")
    const readCurrentReport =()=> generatePDFPlay(this.state.filteredInfo,"read")

    const downloadPlayReportSelectedCountry=()=> generatePDFPlay(this.state.plays.filter(p=>Object.entries(p.conc)[0][1]['pais'] == getCountryCode(this.state.reportCountry)),"save",false,true,this.state.reportCountry)
    const readPlayReportSelectedCountry =()=> generatePDFPlay(this.state.plays.filter(p=>Object.entries(p.conc)[0][1]['pais'] == getCountryCode(this.state.reportCountry)),"read",false,true,this.state.reportCountry)

    const downloadPlayReportGenreS =()=> generatePDFPlay(this.state.plays.filter(p=>p.category == this.state.reportGenre),"save")
    const readPlayReportGenreS =()=> generatePDFPlay(this.state.plays.filter(p=>p.category == this.state.reportGenre),"read")
    /////////Pseudo/////
    const downloadPlayReportPseudo =()=> generatePDFPlay(this.state.plays,"save",false,false,'',false)
    const readPlayReportPseudo =()=> generatePDFPlay(this.state.plays,"read",false,false,'',false)

    const downloadPlayReportGenrePseudo =()=> generatePDFPlay(this.state.plays,"save",true,false,'',false)
    const readPlayReportGenrePseudo =()=> generatePDFPlay(this.state.plays,"read",true,false,'',false)

    const downloadCurrentReportPseudo =()=> generatePDFPlay(this.state.filteredInfo,"save",false,false,'',false)
    const readCurrentReportPseudo =()=> generatePDFPlay(this.state.filteredInfo,"read",false,false,'',false)

    const downloadPlayReportSelectedCountryPseudo=()=> generatePDFPlay(this.state.plays.filter(p=>Object.entries(p.conc)[0][1]['pais'] == this.getCountryCode(this.state.reportCountry)),"save",false,true,this.state.reportCountry,false)
    const readPlayReportSelectedCountryPseudo =()=> generatePDFPlay(this.state.plays.filter(p=>Object.entries(p.conc)[0][1]['pais'] == this.getCountryCode(this.state.reportCountry)),"read",false,true,this.state.reportCountry,false)

    const downloadPlayReportGenreSPseudo =()=> generatePDFPlay(this.state.plays.filter(p=>p.category == this.state.reportGenre),"save",false,false,'',false)
    const readPlayReportGenreSPseudo =()=> generatePDFPlay(this.state.plays.filter(p=>p.category == this.state.reportGenre),"read",false,false,'',false)

    ///Conc////
    const downloadConcReport =()=> generatePDFConc(this.state.conc,"save")
    const readConcReport =()=> generatePDFConc(this.state.conc,"read")
    ////


const onClickGenreReport=()=>{
  this.setState({makeGenreReport:true})
}
const onClosekGenreReport=()=>{
  this.setState({makeGenreReport:false})
}
const onChangeReportGenre = (value) =>{this.setState({reportGenre:value})}


const onClickCountryReport=()=>{
  this.setState({makeCountryReport:true})
}
const onClosekCountryReport=()=>{
  this.setState({makeCountryReport:false})
}
const onChangeReportCountry = (value) =>{this.setState({reportCountry:value})}
      const {  Content } = Layout;
      const columns = [
                
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Número</div>,
                    dataIndex: 'code',
                    key: 'code',
                    width:'8%',
                    ...this.getColumnSearchProps('code','número'),
                    responsive: ['sm'] 
                  },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Título</div>,
                    dataIndex: 'title',
                    key: 'title',
                    sorter: (a, b) => a.title.localeCompare(b.title),
                    ...this.getColumnSearchProps('title','título'),
                    responsive: ['sm'] 
                  },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Seudónimo</div>,
                    dataIndex: 'pseudo',
                    key: 'pseudo',
                    width:'10%',
                    ...this.getColumnSearchProps('pseudo','seudónimo'),
                    responsive: ['sm'] 
                  },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Autor(es)</div>,
                    dataIndex: 'author',
                    key: 'author',
                    ...this.getColumnSearchProps('author','autor'),
                    responsive: ['sm'] 
                  },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Género</div>,
                    dataIndex: 'category',
                    key: 'category',
                    width:'8%',
                    ...this.getColumnSearchProps('category','género'),
                    responsive: ['sm'] 
                  },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Fecha</div>,
                    dataIndex: 'date',
                    key: 'date',
                    width:'8%',
                    sorter:(a,b) => moment.utc(a.unixDate).diff(moment.utc(b.unixDate)),
                    sortDirections:['ascend', 'descend', 'ascend'],
                    ...this.getColumnSearchProps('date','fecha'),
                    responsive: ['sm'] 
                  },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Calificada</div>,
                    dataIndex: 'qualified',
                    key: 'qualified',
                    width:'100px',
                    render: (text,record) =>(
                      <Row  align="middle" justify="center"  >
                        <Col >
                            {record.qualified != undefined ? (record.qualified ? <a onClick={()=>this.changeQualification(record.id,null)}><LikeOutlined  style={{color:'green'}} /></a>:<a onClick={()=>this.changeQualification(record.id,true)}> <DislikeOutlined  /></a>): <a onClick={()=>this.changeQualification(record.id,false)}> <MinusOutlined /></a>}
                        </Col>
                      </Row>
                      ),
                    sortDirections:['ascend', 'descend', 'ascend'],
                    responsive: ['sm'] ,
                    sortDirections:['ascend', 'descend', 'ascend'],
                    responsive: ['sm'] 
                  },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Preseleccionada</div>,
                    dataIndex: 'preselected',
                    key: 'preselected',
                    width:'155px',
                    render: (text,record) =>(

                      <Row align="middle" justify="center"  >
                        <Col >
                            {record.preselected != undefined ? (record.preselected ? <a onClick={()=>this.changePreselection(record.id,null)}><LikeOutlined   style={{color:'green'}} /></a>: <a onClick={()=>this.changePreselection(record.id,true)}><DislikeOutlined   /></a>): <a onClick={()=>this.changePreselection(record.id,false)}><MinusOutlined  /></a>}
                        </Col>
                      </Row>
                       
                      ),
                    sortDirections:['ascend', 'descend', 'ascend'],
                    responsive: ['sm'] 
                  },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large'}}>Editar</div>,
                    dataIndex: 'edit',
                    key: 'edit',
                    width:'5%',
                    render: (text,record) =>(
                      <div  style={{fontSize:'large' }}>
                      <a onClick={()=>{this.onClickEditPlay(record)}}> <EditOutlined /></a>
                      </div>
                      ),
                    sortDirections:['ascend', 'descend', 'ascend'],
                    responsive: ['sm'] 
                    
                  },
                  {
                    title: <div style={{fontWeight:'bold', fontSize:'large' }}>Obra</div>,
                    sorter: (a, b) => a.name.localeCompare(b.name),
                    sortDirections:['ascend', 'descend', 'ascend'],
                    ...this.getColumnSearchProps('name','nombre'),
                    render: (record) => (
                      <React.Fragment>
                        <a onClick = {()=>this.onClickArticle(record)} >   
                        <b style={{fontSize:'large'}}>{record.title}</b>
                        </a>

                        <br />
                        <b>Código:</b>{record.code}
                        <br />
                        <b>Seudónimo:</b>{record.pseudo}
                        <br />
                        <b>Autor(es):</b><ol>{record.author.map((a,idx)=>{return <li>{a.name} </li>})}</ol> 
                        <b>Género:</b>{record.category}
                        <br />
                        <b>Fecha:</b>{record.date}
                      </React.Fragment>
                    ),
                    responsive: ['xs'] 
                  },
                  {
                    dataIndex: 'edit',
                    key: 'edit',
                    width:'15%',
                    render: (text,record) =>(
                                <div  style={{fontSize:'large' }}>
                                <a onClick={()=>{this.onClickEditPlay(record)}}> <EditOutlined /></a>
                                </div>
                    ),
                    sortDirections:['ascend', 'descend', 'ascend'],
                    responsive: ['xs'] 
                  },
            ];

    const url = this.state.record?.pdf
    const downloadUrl = IP + 'api/casa/file/'+ this.state.record?.id

    const readFile =  ()=>{
      window.open(url)
    };
    const downloadFile=()=>{
      fetch(downloadUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/pdf"
        }
      })
        .then(res => res.blob())
        .then(response => {
          //Create a Blob from the PDF Stream
          const blob = new Blob([response], {
            type: "application/pdf"
          });
          //Build a URL from the file
          // const fileURL = URL.createObjectURL(file);

          const link = document.createElement('a');
          // create a blobURI pointing to our Blob
          link.href = URL.createObjectURL(blob);
          link.download = this.state.record.code;
          // some browser needs the anchor to be in the doc
          document.body.append(link);
          link.click();
          link.remove();
          // in case the Blob uses a lot of memory
          setTimeout(() => URL.revokeObjectURL(link.href), 7000);
          //Open the URL on new Window
          // window.open(fileURL);
        })
        .catch(error => {
          console.log(error);
        });
    }

    const closeComments=()=>{
      this.setState({showCommentSection:false,editComment:false, selected_comment:undefined})
    }
    const { SubMenu } = Menu;
    const { Option } = Select;
    const { TabPane } = Tabs;
    const { TextArea } = Input;
    const reportMenu = (
      <SubMenu disabled={!this.state.logued} key="reports" icon={<BarChartOutlined style={{ fontSize: '26px'}} />} style={{fontSize:'20px', fontWeight:'bold', color:'black'}} title="Reportes">
        <SubMenu  key="play" title ={<h4 style={{ fontWeight:'bold', color:'black'}}>Reportes de obras</h4>}>
          <SubMenu  key="playAuth" title ={<h4 style={{ fontWeight:'bold', color:'black'}}>Con autores</h4>}>
            <Menu.ItemGroup title={<h4 style={{  color:'black'}}>General</h4>}>
              <Menu.Item>
                  <Button onClick={readPlayReport}>Ver</Button> <Button onClick={downloadPlayReportPseudo}>Descargar</Button>
              </Menu.Item>
            </Menu.ItemGroup>

            <Menu.ItemGroup title={<h4 style={{  color:'black'}}>Agrupadas por género</h4>}>
              <Menu.Item>
                  <Button onClick={readPlayReportGenre}>Ver</Button> <Button onClick={downloadPlayReportGenrePseudo}>Descargar</Button>
              </Menu.Item>
            </Menu.ItemGroup>
              
            <Menu.ItemGroup title={<h4 style={{  color:'black'}}>Tabla actual</h4>}>
              <Menu.Item>
                  <Button onClick={readCurrentReport}>Ver</Button> <Button onClick={downloadCurrentReport}>Descargar</Button>
              </Menu.Item>
            </Menu.ItemGroup>
            
            <Menu.Item>
              <h4 onClick={()=>{this.setState({reportByAuthor:true},()=>onClickCountryReport())}}  style={{  color:'black'}}>Por país específico</h4>
            </Menu.Item>

            <Menu.Item style={{ fontWeight:'bold'}} >
              <h4 onClick={()=>{this.setState({reportByAuthor:true},()=>onClickGenreReport())}}  style={{  color:'black'}}>Por Genero</h4>
            </Menu.Item>
          </SubMenu>
          <SubMenu  key="playPseudo" title ={<h4 style={{ fontWeight:'bold', color:'black'}}>Con seudónimo</h4>}>
            <Menu.ItemGroup title={<h4 style={{  color:'black'}}>General</h4>}>
              <Menu.Item>
                  <Button onClick={readPlayReportPseudo}>Ver</Button> <Button onClick={downloadPlayReport}>Descargar</Button>
              </Menu.Item>
            </Menu.ItemGroup>

            <Menu.ItemGroup title={<h4 style={{  color:'black'}}>Agrupadas por género</h4>}>
              <Menu.Item>
                  <Button onClick={readPlayReportGenrePseudo}>Ver</Button> <Button onClick={downloadPlayReportGenre}>Descargar</Button>
              </Menu.Item>
            </Menu.ItemGroup>
              
            <Menu.ItemGroup title={<h4 style={{  color:'black'}}>Tabla actual</h4>}>
              <Menu.Item>
                  <Button onClick={readCurrentReportPseudo}>Ver</Button> <Button onClick={downloadCurrentReportPseudo}>Descargar</Button>
              </Menu.Item>
            </Menu.ItemGroup>
            <Menu.Item>
                <h4 onClick={()=>{this.setState({reportByAuthor:false},()=>onClickCountryReport())}}  style={{  color:'black'}}>Por país específico</h4>
            </Menu.Item>

            <Menu.Item style={{ fontWeight:'bold'}} >
              <h4 onClick={()=>{this.setState({reportByAuthor:false},()=>onClickGenreReport())}}  style={{  color:'black'}}>Por Genero</h4>
            </Menu.Item>
          </SubMenu>
        </SubMenu>
      <SubMenu  key="rep_conc" title = {<h4 style={{ fontWeight:'bold', color:'black'}}>Reportes de concursantes</h4>}>
        <Menu.ItemGroup style={{ fontWeight:'bold'}} title={<h4 style={{  color:'black'}}>General</h4>}>
          <Menu.Item>
            <Button onClick={readConcReport}>Ver</Button> <Button onClick={downloadConcReport}>Descargar</Button>
          </Menu.Item>
        </Menu.ItemGroup>
      </SubMenu>
  </SubMenu>
    )
    return (
      <div className="page-container">
      <div className = "content-wrap">
      <ConfigProvider locale={es_ES}>
            <Layout style={{backgroundColor:'white'}}>
               <AdminMenu defaultSelectedKey={"plays"} reportMenu={reportMenu} />
            <Spin spinning={this.state.isBusy || !this.state.logued} >
            <Content>
              <Tabs  type="card" defaultActiveKey="1" onChange={(key)=>this.onchangeTab(key)} >
                <TabPane tab="Todas las Obras" key="1">
                  <Card>
                    {this.state.selectedRows.length > 0 && 
                    <Row gutter={10}>
                      <Col>
                        <Button onClick={()=>this.qualifyAll()}>Calificar</Button>
                      </Col>
                      <Col>
                        <Button onClick={()=>this.unqualifyAll()}>Descalificar</Button>
                      </Col>
                      <Col>
                        <Button onClick={()=>this.undefinedQualifyAll()}>Sin determinar calificación</Button>
                      </Col>
                    
                      <Col>
                        <Button onClick={()=>this.preselectAll()}>Preseleccionar</Button>
                      </Col>
                      <Col>
                        <Button onClick={()=>this.depreselectAll()}>No Preseleccionar</Button>
                      </Col>
                      <Col>
                      </Col>
                    </Row>}
                <Row>
                <Col span={24}>
                  <Table
                    rowSelection={{
                      columnTitle:<Checkbox onChange={(e)=>this.setState({selectedRows: !e.target.checked ? []:this.state.plays.map(p=>p.id) })}></Checkbox>,
                      selectedRowKeys:this.state.selectedRows,
                      onChange:(rows)=>this.onChangeSelectedRows(rows),
                    }}
                    bordered
                    columns={columns}
                    dataSource= {this.state.plays}
                    pagination={{ position: ["bottomCenter"],}} 
                    tableLayout='fixed'
                    size='small'
                    style={{ whiteSpace: 'normal'}}
                    onChange = {this.handleTableChange}
                  />
                </Col>
              </Row>
              </Card>
                </TabPane>
                <TabPane tab="Calificadas" key="2">
                <Card>
                 {this.state.selectedRows.length > 0 && <Row gutter={10}>
                 <Col>
                      <Button onClick={()=>this.qualifyAll()}>Calificar</Button>
                    </Col>
                    <Col>
                      <Button onClick={()=>this.unqualifyAll()}>Descalificar</Button>
                    </Col>
                   
                    <Col>
                      <Button onClick={()=>this.preselectAll()}>Preseleccionar</Button>
                    </Col>
                    <Col>
                      <Button onClick={()=>this.depreselectAll()}>No Preseleccionar</Button>
                    </Col>
                  </Row>}
                <Row>
                <Col span={24}>
                  <Table
                    bordered
                    rowSelection={{
                      columnTitle:<Checkbox onChange={(e)=>this.setState({selectedRows: !e.target.checked ? [] : this.state.plays.filter(p=>p.qualified).map(p=>p.id) })}></Checkbox>,
                      selectedRowKeys:this.state.selectedRows,
                      onChange:(rows)=>this.onChangeSelectedRows(rows),
                
                    }}
                    columns={columns}
                    dataSource= {this.state.plays.filter(p=>p.qualified)}
                    pagination={{ position: ["bottomCenter"],}} 
                    tableLayout='fixed'
                    size='small'
                    style={{ whiteSpace: 'normal'}}
                    onChange = {this.handleTableChange}
                  />
                </Col>
              </Row>
              </Card>
                </TabPane>
                <TabPane tab="Descalificadas" key="3">
                <Card>
                 {this.state.selectedRows.length > 0 && <Row gutter={10}>
                 <Col>
                      <Button onClick={()=>this.qualifyAll()}>Calificar</Button>
                    </Col>
                    <Col>
                      <Button onClick={()=>this.unqualifyAll()}>Descalificar</Button>
                    </Col>
                   
                    <Col>
                      <Button onClick={()=>this.preselectAll()}>Preseleccionar</Button>
                    </Col>
                    <Col>
                      <Button onClick={()=>this.depreselectAll()}>No Preseleccionar</Button>
                    </Col>
                  </Row>}
                    <Row>
                      <Col span={24}>
                        <Table
                          bordered
                          rowSelection={{
                            columnTitle:<Checkbox onChange={(e)=>this.setState({selectedRows: !e.target.checked ? []:this.state.plays.filter(p=>p.qualified==undefined ? false:!p.qualified).map(p=>p.id) })}></Checkbox>,
                            selectedRowKeys:this.state.selectedRows,
                            onChange:(rows)=>this.onChangeSelectedRows(rows),
                      
                          }}
                          columns={columns}
                          dataSource= {this.state.plays.filter(p=>p.qualified==undefined ? false:!p.qualified)}
                          pagination={{ position: ["bottomCenter"],}} 
                          tableLayout='fixed'
                          size='small'
                          style={{ whiteSpace: 'normal'}}
                          onChange = {this.handleTableChange}
                        />
                      </Col>
                  </Row>
                  </Card>
                </TabPane>
                <TabPane tab="Sin determinar calificación" key="4">
                <Card>
                 {this.state.selectedRows.length > 0 && <Row gutter={10}>
                 <Col>
                      <Button onClick={()=>this.qualifyAll()}>Calificar</Button>
                    </Col>
                    <Col>
                      <Button onClick={()=>this.unqualifyAll()}>Descalificar</Button>
                    </Col>
                   
                    <Col>
                      <Button onClick={()=>this.preselectAll()}>Preseleccionar</Button>
                    </Col>
                    <Col>
                      <Button onClick={()=>this.depreselectAll()}>No Preseleccionar</Button>
                    </Col>
                  </Row>}
                    <Row>
                      <Col span={24}>
                        <Table
                          bordered
                          rowSelection={{
                            columnTitle:<Checkbox onChange={(e)=>this.setState({selectedRows: !e.target.checked ? []:this.state.plays.filter(p=>p.qualified==undefined).map(p=>p.id) })}></Checkbox>,
                            selectedRowKeys:this.state.selectedRows,
                            onChange:(rows)=>this.onChangeSelectedRows(rows),
                      
                          }}
                          columns={columns}
                          dataSource= {this.state.plays.filter(p=>p.qualified==undefined)}
                          pagination={{ position: ["bottomCenter"],}} 
                          tableLayout='fixed'
                          size='small'
                          style={{ whiteSpace: 'normal'}}
                          onChange = {this.handleTableChange}
                        />
                      </Col>
                  </Row>
                  </Card>
                </TabPane>
                <TabPane tab="Preseleccionadas" key="5">
                <Card>
                 {this.state.selectedRows.length > 0 && <Row gutter={10}>
                 <Col>
                      <Button onClick={()=>this.qualifyAll()}>Calificar</Button>
                    </Col>
                    <Col>
                      <Button onClick={()=>this.unqualifyAll()}>Descalificar</Button>
                    </Col>
                   
                    <Col>
                      <Button onClick={()=>this.preselectAll()}>Preseleccionar</Button>
                    </Col>
                    <Col>
                      <Button onClick={()=>this.depreselectAll()}>No Preseleccionar</Button>
                    </Col>
                  </Row>}
                <Row>
                <Col span={24}>
                  <Table
                    bordered
                    rowSelection={{
                      columnTitle:<Checkbox onChange={(e)=>this.setState({selectedRows: !e.target.checked? []:this.state.plays.filter(p=>p.preselected).map(p=>p.id) })}></Checkbox>,
                      selectedRowKeys:this.state.selectedRows,
                      onChange:(rows)=>this.onChangeSelectedRows(rows),
                
                    }}
                    columns={columns}
                    dataSource= {this.state.plays.filter(p=>p.preselected)}
                    pagination={{ position: ["bottomCenter"],}} 
                    tableLayout='fixed'
                    size='small'
                    style={{ whiteSpace: 'normal'}}
                    onChange = {this.handleTableChange}
                  />
                </Col>
              </Row>
              </Card>
                </TabPane>
                <TabPane tab="No Preseleccionadas" key="6">
                <Card>
                 {this.state.selectedRows.length > 0 && <Row gutter={10}>
                 <Col>
                      <Button onClick={()=>this.qualifyAll()}>Calificar</Button>
                    </Col>
                    <Col>
                      <Button onClick={()=>this.unqualifyAll()}>Descalificar</Button>
                    </Col>
                   
                    <Col>
                      <Button onClick={()=>this.preselectAll()}>Preseleccionar</Button>
                    </Col>
                    <Col>
                      <Button onClick={()=>this.depreselectAll()}>No Preseleccionar</Button>
                    </Col>
                  </Row>}
                    <Row>
                      <Col span={24}>
                        <Table
                          bordered
                          rowSelection={{
                            columnTitle:<Checkbox onChange={(e)=>this.setState({selectedRows: !e.target.checked ? []:this.state.plays.filter(p=>p.preselected==undefined ? false:!p.preselected).map(p=>p.id) })}></Checkbox>,
                            selectedRowKeys:this.state.selectedRows,
                            onChange:(rows)=>this.onChangeSelectedRows(rows),
                      
                          }}
                          columns={columns}
                          dataSource= {this.state.plays.filter(p=>p.preselected==undefined ? false:!p.preselected)}
                          pagination={{ position: ["bottomCenter"],}} 
                          tableLayout='fixed'
                          size='small'
                          style={{ whiteSpace: 'normal'}}
                          onChange = {this.handleTableChange}
                        />
                      </Col>
                  </Row>
                  </Card>
                </TabPane>
                <TabPane tab="Sin determinar preselección" key="7">
                <Card>
                 {this.state.selectedRows.length > 0 && <Row gutter={10}>
                 <Col>
                      <Button onClick={()=>this.qualifyAll()}>Calificar</Button>
                    </Col>
                    <Col>
                      <Button onClick={()=>this.unqualifyAll()}>Descalificar</Button>
                    </Col>
                   
                    <Col>
                      <Button onClick={()=>this.preselectAll()}>Preseleccionar</Button>
                    </Col>
                    <Col>
                      <Button onClick={()=>this.depreselectAll()}>No Preseleccionar</Button>
                    </Col>
                  </Row>}
                    <Row>
                      <Col span={24}>
                        <Table
                          bordered
                          rowSelection={{
                            columnTitle:<Checkbox onChange={(e)=>this.setState({selectedRows: !e.target.checked ? []:this.state.plays.filter(p=>p.preselected==undefined).map(p=>p.id) })}></Checkbox>,
                            selectedRowKeys:this.state.selectedRows,
                            onChange:(rows)=>this.onChangeSelectedRows(rows),
                      
                          }}
                          columns={columns}
                          dataSource= {this.state.plays.filter(p=>p.preselected==undefined)}
                          pagination={{ position: ["bottomCenter"],}} 
                          tableLayout='fixed'
                          size='small'
                          style={{ whiteSpace: 'normal'}}
                          onChange = {this.handleTableChange}
                        />
                      </Col>
                  </Row>
                  </Card>
                </TabPane>
              </Tabs>
              {
                    this.state.showArticle && 
                    <Modal 
                        closable = {false}
                        title={ this.state.record.code}
                        visible={this.state.showArticle} 
                        onCancel={this.hideModal}
                        footer={[
                          
                            <Button key="back" onClick={this.hideModal}>
                            Regresar
                            </Button>,
                             
                        ]}
                    >
                        {this.state.record.author.map((a,idx)=>{return <p><UserOutlined />Autor: {a.name} </p>})}

                         <p><FileTextOutlined />Título: {this.state.record.title}</p>
                        
                        <p><QrcodeOutlined />Código: {this.state.record.code}  </p>
                        <p><CalendarOutlined />Fecha: {this.state.record.date}   </p>

                        <p><TagsOutlined />Género: 
                          {this.state.record.category} 
                        </p>
                        
                        <p><AuditOutlined />Seudónimo: {this.state.record.pseudo} </p>
                        <p>
                          <CheckOutlined />Calificada: {this.state.record.qualified == undefined ? "Sin Determinar":(this.state.record.qualified ? "Calificada":"Descalificada" )  }
                          </p>
                          <p>
                          <StarOutlined />Preseleccionada: {this.state.record.preselected == undefined ? "Sin Determinar":(this.state.record.preselected ? "Preseleccionada":"No Preseleccionada" )  }
                          </p>
                        <p>

                         <Button onClick={readFile}><FilePdfOutlined/> Leer PDF</Button>
                          <Button onClick={downloadFile} >
                            <FilePdfOutlined/>  Descargar PDF
                          </Button>
                          <Badge>
                          <Button onClick={() => this.openComments(this.state.record)} >
                            <FileTextOutlined />  Comentarios</Button></Badge>
                        </p>

                    </Modal>
                    || (this.state.edit && 
                      <Modal 
                          closable = {false}
                          title={ this.state.record.code}
                          visible={this.state.edit} 
                          onCancel={this.hideEdit}
                          footer={[
                            <Button key="save" onClick={()=>this.onClickSave()}>
                            Guardar
                            </Button>,
                              <Button key="back" onClick={this.hideEdit}>
                              Regresar
                              </Button>,
                               
                          ]}
                          >
                         {this.state.record.author.map((a,idx)=>{return <p><UserOutlined />Autor: {a.name} </p>})}
                           <p><FileTextOutlined />Título: <Input style={{width:'80%'}} defaultValue={this.state.record.title} id ="inputTitle" /></p>
                          
                          <p><QrcodeOutlined />Código: {this.state.record.code}  </p>
                          <p><CalendarOutlined />Fecha: {this.state.record.date}   </p>
  
                          <p><TagsOutlined />Género: 
                            <Select defaultValue={this.state.record.category} onChange={(value)=>this.onChangeSelect(value)} style={{marginLeft:5}}>
                            
                            {this.json_g.map((g)=>{return <Option value={g.id}>{this.genres_dict[g.id]}</Option>})}
                            </Select>  
                          </p>
                          <p><AuditOutlined />Seudónimo: <Input defaultValue={this.state.record.pseudo}style={{width:'70%'}} id="inputPseudo"/></p>
                          <p>
                          <CheckOutlined />Calificada: 
                            <Select defaultValue={this.state.record.qualified } style={{marginLeft:5}} onChange={(value)=>this.setState({qualifiedChangedValue:value, qualifiedChanged:true})}>
                              <Option value={true}>Calificada</Option>
                              <Option value={false}>Descalificada</Option>
                              <Option value={undefined}>Sin Determinar</Option>
                            </Select>  
                          </p>
                          <p>
                          <StarOutlined />Preseleccionada:
                            <Select defaultValue={this.state.record.preselected} style={{marginLeft:5}} onChange={(value)=>this.setState({preselectedChangedValue:value,preselectedChanged:true})}>
                              <Option value={true}>Preseleccionada</Option>
                              <Option value={false}>No Preseleccionada</Option>
                              <Option value={undefined}>Sin Determinar</Option>
                            </Select>  
                          </p>
                          <p>
                            
                            <Button onClick={readFile}><FilePdfOutlined/> Leer PDF</Button>
                            <Button onClick={downloadFile} >
                            <FilePdfOutlined/>  Descargar PDF
                              </Button>
                          </p>
  
                      </Modal>)
                      }
                        {this.state.makeGenreReport &&
              <Modal
              closable = {false}
              title="Reporte por género"
              visible={this.state.makeGenreReport}
              footer={[
                <Button key="back" onClick={onClosekGenreReport}>
                Regresar
                </Button>,
            ]}
              >
                  <Select
                   style={{width:'80%'}}
                   defaultValue={this.state.reportGenre}
                   onChange={onChangeReportGenre}
                   >
                    {this.categories.map(element => {return <Option value={Object.entries(element)[0][1]}>{Object.entries(element)[0][1]}</Option>})}
                  </Select>
                  <div>
                    <br/>
                  <Button onClick={this.state.reportByAuthor ? readPlayReportGenreS:readPlayReportGenreSPseudo }>Ver</Button> <Button onClick={this.state.reportByAuthor ? downloadPlayReportGenreS:downloadPlayReportGenreSPseudo }>Descargar</Button>

                  </div>
               

              </Modal>}

              {this.state.makeCountryReport &&
              <Modal
              closable = {false}
              title="Reporte por país"
              visible={this.state.makeCountryReport}
              footer={[
                <Button key="back" onClick={onClosekCountryReport}>
                Regresar
                </Button>,
            ]}
              >
                  <Select
                   style={{width:'80%'}}
                   defaultValue={this.state.reportCountry}
                   onChange={onChangeReportCountry}
                   >
                    {[...this.countries].map(c => {return <Option value={c}>{c}</Option>})}
                  </Select>
                  <div>
                    <br/>
                    <Button onClick={this.state.reportByAuthor ? readPlayReportSelectedCountry : readPlayReportSelectedCountryPseudo}>Ver</Button> <Button onClick={this.state.reportByAuthor ? downloadPlayReportSelectedCountry:downloadPlayReportSelectedCountryPseudo}>Descargar</Button>
                  </div>
              </Modal>}
              { this.state.showCommentSection && <Modal 
                          closable = {false}
                          title={ "Comentarios"}
                          visible={this.state.showCommentSection} 
                          width={580}
                          footer={[
                           
                              <Button key="backComment" onClick={closeComments}>
                              Cerrar
                              </Button>,
                               
                          ]}
                          >
                         <Row align="middle" justify="center" >
                           <Col span={24}>
                           <Comment
                              actions={[<Button type="primary" disabled={this.state.edit_comment || !this.state.comment_new_text || this.state.comment_new_text.replaceAll(/\s/g,'') === ""} onClick={()=>this.postComment(this.state.record.id)} >Comentar</Button>, <Button type="text" onClick={()=>this.cancelComment()} >Cancelar</Button>]}
                              avatar={
                                  <Avatar
                                    src={`https://ui-avatars.com/api/name=${this.state.jurys_dict[this.state.juryId].nombre_completo}&background=random`}
                                    alt={this.state.jurys_dict[this.state.juryId].nombre_completo}
                                  />
                              }
                              content={
                                <TextArea disabled={this.state.edit_comment} placeholder={"Añadir comentario"} value={!this.state.edit_comment && this.state.comment_new_text} onChange={(val)=>{this.setState({comment_new_text:val.target.value})}}/>
                              }
                            />
                            {
                              Object.entries(this.state.comment).map(element=>{
                                if (!element[1].comentario_padre){
                                  return this.getChildComments(element[1])
                                }
                              })
                              
                            }
                           </Col>
                         </Row>
                      </Modal>}
                      {
                    this.state.showAuthor && 
                    <Modal 
                    closable = {false}
                        title={"Detalles de autor"}
                        visible={this.state.showAuthor} 
                        onCancel={()=>this.setState({showAuthor:false,record:null,recordAuthor:null})}
                        footer={[
                            <Button key="back" onClick={()=>this.setState({showAuthor:false,record:null,recordAuthor:null})}>
                            Regresar
                            </Button>,
                        ]}
                        >
                        <p><UserOutlined /> Nombre: {this.state.record.conc[this.state.recordAuthor].nombre_completo}</p>
                        <p><MailOutlined /> Email: {this.state.record.conc[this.state.recordAuthor].email}</p>
                        <p><PhoneOutlined /> Teléfono: {this.state.record.conc[this.state.recordAuthor].telefono}</p>
                        <p><GlobalOutlined /> País: { getCountryName(this.state.record.conc[this.state.recordAuthor].pais)}</p>
                        <p><EnvironmentOutlined /> Dirección: {this.state.record.conc[this.state.recordAuthor].direcc_personal}</p>
                        <p><IdcardOutlined /> Ficha: {this.state.record.conc[this.state.recordAuthor].ficha}</p>
                    </Modal>
                    }
            </Content>
            </Spin>
          </Layout>
         
        </ConfigProvider>
    </div>
    <Foot admin={true}/>
    </div>

    );
  }
}
export default Playslist;


